module.exports = __webpack_public_path__ + "img/ic-8.dbf9f79.svg";